export const ACTIVE_SESSION_UNLOAD_MESSAGE =
  "You have an active session. Leaving will pause your timer. Your session will not be exited."

const emptySnapshot = () => ({
  sessionId: null,
  token: null,
  shouldPause: false,
})

let snapshot = emptySnapshot()
let unloadSent = false

const apiOrigin = () =>
  String(process.env.REACT_APP_BASEURL || "").replace(/\/$/, "")

export const getActiveSessionSnapshot = () => snapshot

export const syncActiveSessionSnapshot = next => {
  const sessionId = next?.sessionId ? String(next.sessionId) : null
  if (snapshot.sessionId !== sessionId) {
    unloadSent = false
  }
  snapshot = {
    sessionId,
    token: next?.token || snapshot.token || null,
    shouldPause: Boolean(next?.shouldPause),
  }
}

export const clearActiveSessionSnapshot = () => {
  snapshot = emptySnapshot()
  unloadSent = false
}

export const markUnloadHandled = () => {
  unloadSent = true
}

const postKeepalive = (path, body, token) => {
  if (!token || typeof fetch !== "function") return
  fetch(`${apiOrigin()}${path}`, {
    method: "POST",
    keepalive: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch(() => {})
}

/**
 * Pause the running timer on tab/browser close. Does not leave/exit
 * the session — the user can resume after signing back in.
 */
export const sendUnloadPause = (reason = "Left the application") => {
  if (unloadSent) return
  const { sessionId, token, shouldPause } = snapshot
  if (!sessionId || !token || !shouldPause) return

  unloadSent = true
  postKeepalive(
    `/api/v1/sessions/${sessionId}/timelog`,
    { action: "break", reason },
    token,
  )
}
